import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Top Section */}
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="w-10 h-10 bg-teal-600 rounded-lg flex items-center justify-center">
              <i className="ri-robot-2-line text-white text-xl"></i>
            </div>
            <span className="text-2xl font-bold">Automigo</span>
          </div>
          <p className="text-gray-400 text-sm">
            Serving businesses across Long Island, NY
          </p>
        </div>

        {/* Links */}
        <div className="flex flex-wrap justify-center gap-6 mb-12 text-sm">
          <Link to="/about-us" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
            About
          </Link>
          <Link to="/how-it-works" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
            How It Works
          </Link>
          <a 
            href="#cta-form" 
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('cta-form')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="text-gray-400 hover:text-white transition-colors cursor-pointer"
          >
            Contact
          </a>
          <Link to="/terms-and-conditions" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
            Messaging Terms
          </Link>
          <Link to="/privacy-policy" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
            Privacy
          </Link>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-800 pt-8 text-center">
          <p className="text-gray-500 text-sm mb-4">
            Helping service businesses capture more customers automatically
          </p>
          <p className="text-gray-600 text-xs">
            © {new Date().getFullYear()} Automigo. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?ref=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-gray-600 hover:text-gray-400 text-xs mt-2 inline-block transition-colors cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
